import React from "react";
import "./Title.module.css";

const Title = ({ title, textPosition = "center" }) => {
  const isLeft = textPosition === "left";
  const isRight = textPosition === "right";

  return (
    <div className="title-container">
      {!isLeft && <div className="title-line"></div>}

      <h2 className="title-text">{title}</h2>

      {!isRight && <div className="title-line"></div>}
    </div>
  );
};

export default Title;
